import {
  EditorField,
  SelectField,
  TextareaField,
  TextField,
} from "components/form/fields";
import { Column, Row } from "components/layout";
import { TiVoLaunchAttributes, URL_PARAMETER_PLACEMENT } from "hooks/tivoApps";
import { toFieldValues } from "utils/formik";

import { TEXTS } from "../constants";
import { FIELDS_LAUNCH_CONFIG_TAB } from "../fields";
import { ListField } from "./ListField";

export type LaunchAttributesProps = {
  mode: "intent" | "uri";
  name: string;
};

export function LaunchAttributes({ mode, name }: LaunchAttributesProps) {
  const getField = (key: keyof typeof FIELDS_LAUNCH_CONFIG_TAB) => {
    const { modes, name: suffix, ...field } = FIELDS_LAUNCH_CONFIG_TAB[key];
    return { ...field, name: `${name}.${suffix}` };
  };

  const renderFields = () => {
    if (mode === "intent") {
      return (
        <>
          <EditorField {...getField("INTENT")} />
          <EditorField {...getField("ATTRS_WITH_CRIT")} />
        </>
      );
    }
    if (mode === "uri") {
      return (
        <>
          <TextField {...getField("PLAYBACK_URI")} />
          <TextareaField {...getField("AD_PARAMS")} />
          <ListField<
            NonNullable<TiVoLaunchAttributes["appendUrlParameters"]>[number]
          >
            {...getField("APPEND_URL_PARAMS")}
            template={FIELDS_LAUNCH_CONFIG_TAB.APPEND_URL_PARAMS.template}
            draggable
          >
            {({ name, ...field }) => (
              <Row>
                <Column>
                  <TextField
                    {...field}
                    name={`${name}.name`}
                    look="simple"
                    placeholder={TEXTS.LAUNCH_CONFIG.NAME_PLACEHOLDER}
                  />
                  <TextField
                    {...field}
                    name={`${name}.key`}
                    look="simple"
                    placeholder={TEXTS.LAUNCH_CONFIG.KEY_PLACEHOLDER}
                  />
                </Column>
                <Column>
                  <TextField
                    {...field}
                    name={`${name}.value`}
                    look="simple"
                    placeholder={TEXTS.LAUNCH_CONFIG.VALUE_PLACEHOLDER}
                  />
                  <SelectField
                    {...field}
                    name={`${name}.placement`}
                    look="simple"
                    values={toFieldValues(URL_PARAMETER_PLACEMENT, false)}
                  />
                </Column>
              </Row>
            )}
          </ListField>
          <EditorField {...getField("ATTRS_WITH_CRIT")} />
        </>
      );
    }
    return null;
  };

  return <div>{renderFields()}</div>;
}
